import { useTranslation } from 'react-i18next';
import { useAppState } from 'AppProvider';
import { ReducerState } from 'types/reducer';

export const useGeneratePageTitle = () => {
  const { t: translate } = useTranslation();
  const brandName = useAppState(
    (state: ReducerState) => state.brand.settings.name,
  );

  const generatePageTitle = (
    title?: string,
    translatedTitle?: string,
    subtitle?: string,
  ) => {
    const titleText = title ? translate(title) : translatedTitle;

    if (subtitle) {
      return `${translate(subtitle)} | ${titleText} ${
        brandName ? `| ${brandName}` : ''
      }`;
    }

    return `${titleText} ${brandName ? `| ${brandName}` : ''}`;
  };

  return { generatePageTitle };
};
